import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RemmiDateRangeComponent } from './remmi-date-range.component';
import { PipeDirectiveModule } from '@shared-modules/pipe-directive.module';
import { CalendarModule } from 'primeng/calendar';

@NgModule({
  declarations: [RemmiDateRangeComponent],
  imports: [CommonModule, FormsModule, PipeDirectiveModule, CalendarModule],
  exports: [RemmiDateRangeComponent],
})
export class RemmiDateRangeModule {}
